export const TOP_MESSAGE_BAR_HEIGHT_PX = 44;

export const STOREFRONT_RESERVED_SEGMENTS = new Set([
  'cart',
  'invoice',
  'orders',
  'profile',
  'search',
  'support',
  'receipt',
  // Legacy URLs kept reserved so redirects are never treated as vendor slugs.
  'shop-demo',
  'shop-plp-demo',
  'category-demo',
  'products',
  'categories',
  'wallet',
  'privacy-policy',
  'terms-of-service',
  'withdraw',
  'cashout-details',
  'about-us',
  'contact-us',
  'contact',
  'delivery',
  'faq',
  'privacy-policies',
  'collection',
  'product',
  'return',
  'register',
  'otp',
  'payment',
  'splash',
]);
